"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.match");

var _util = require("@/utils/util");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'OpenInBrowser',
  data: function data() {
    return {
      guidePageShow: true
    };
  },
  created: function created() {
    var _this = this;

    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

    var _this$$route$query = this.$route.query,
        path = _this$$route$query.path,
        mediaId = _this$$route$query.mediaId,
        isLive = _this$$route$query.isLive;

    if ((0, _util.getIsWxClient)() || (0, _util.getIsWeiBoClient)()) {
      return false;
    } else {
      this.guidePageShow = false;
    }

    if (isAndroid) {
      var isVideo = mediaId && isLive;

      if (isVideo) {
        window.location.href = "zunaersecurities://video?mediaId=".concat(mediaId, "&isLive=").concat(isLive);
      } else {
        window.location.href = "zunaersecurities://over2h5/h52app?".concat(path);
      }

      var now = new Date().getTime();
      setTimeout(function () {
        if (new Date().getTime() - now < 2600) {
          var params = {};

          if (isVideo) {
            params.mediaId = mediaId;
            params.isLive = isLive;
          } else {
            params.path = path;
          }

          _this.$router.push({
            name: 'OpenApp',
            query: params
          });
        }
      }, 2000);
    } else if (isiOS) {
      var _isVideo = mediaId && isLive;

      if (_isVideo) {
        window.location.href = "zunaersecurities://video?mediaId=".concat(mediaId, "&isLive=").concat(isLive);
      } else {
        window.location.href = "zunaersecurities://zixun?".concat(path);
      }

      var _now = new Date().getTime();

      setTimeout(function () {
        if (new Date().getTime() - _now < 2600) {
          var params = {};

          if (_isVideo) {
            params.mediaId = mediaId;
            params.isLive = isLive;
          } else {
            params.path = path;
          }

          _this.$router.push({
            name: 'OpenApp',
            query: params
          });
        }
      }, 2000);
    }
  }
};
exports.default = _default;